exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* UU5.Forms.Time */\n.uu5-forms-time {\n  display: inline-block;\n  background: #ffffff;\n  border: 1px solid #d9d9d9;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);\n  border-radius: 0.3em;\n  padding: 0.5em;\n}\n.uu5-forms-time .uu5-bricks-glyphicon {\n  position: relative;\n  padding: 0;\n  width: 1em;\n  height: 1em;\n  font-size: 1.5em;\n}\n.uu5-forms-time .uu5-bricks-button,\n.uu5-forms-time .uu5-bricks-button:active,\n.uu5-forms-time .uu5-bricks-button:focus,\n.uu5-forms-time .uu5-bricks-button:active:focus,\n.uu5-forms-time .uu5-bricks-button:hover {\n  background-color: #fff;\n  width: 2.4em;\n  height: 2.4em;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  outline: none;\n  box-shadow: none;\n}\n.uu5-forms-time-table-column {\n  padding: 0.2em 0.1em;\n  text-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./forms/time.less
// module id = 336
// module chunks = 0